"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useUser = _interopRequireDefault(require("@sprinx/react-auth/useUser"));

var _ShoppingContext = _interopRequireDefault(require("../shop/ShoppingProvider/ShoppingContext"));

var _withNullIfStaticBuild = _interopRequireDefault(require("../withNullIfStaticBuild"));

var defaultCheckoutState = {};

function AppLoadShoppingInfo(_ref) {
  var anonymousContact = _ref.anonymousContact,
      children = _ref.children,
      registerOnAuthenticate = _ref.registerOnAuthenticate,
      registerOnLogout = _ref.registerOnLogout;
  // const authMeta = useAuthMeta();
  var user = (0, _useUser.default)(); // const setRedirect = useRedirect();

  var _React$useContext = _react.default.useContext(_ShoppingContext.default),
      customer = _React$useContext.customer,
      loadShoppingData = _React$useContext.loadShoppingData,
      updateContext = _React$useContext.updateContext;

  var handleLoadShoppingData = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(authCtx) {
      var pUser, partial;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pUser = authCtx.user;
              _context.next = 3;
              return loadShoppingData(pUser);

            case 3:
              partial = _context.sent;
              return _context.abrupt("return", (0, _extends2.default)({}, authCtx, {
                meta: (0, _extends2.default)({}, (authCtx || {}).meta, partial)
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleLoadShoppingData(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleResetShoppingData = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(authCtx) {
      var partial;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              partial = {
                customer: anonymousContact,
                checkoutState: defaultCheckoutState
              };
              updateContext(partial);
              return _context2.abrupt("return", (0, _extends2.default)({}, authCtx, {
                meta: (0, _extends2.default)({}, (authCtx || {}).meta, partial)
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleResetShoppingData(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  _react.default.useEffect(function () {
    var _ref4 = Array.isArray(registerOnAuthenticate) ? registerOnAuthenticate : [registerOnAuthenticate],
        _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
        f = _ref5[0],
        s = _ref5[1];

    var handler = typeof f === 'number' ? s : f;
    var order = typeof f === 'number' ? f : s;
    handler(handleLoadShoppingData, order);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  _react.default.useEffect(function () {
    var _ref6 = Array.isArray(registerOnLogout) ? registerOnLogout : [registerOnLogout],
        _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
        f = _ref7[0],
        s = _ref7[1];

    var handler = typeof f === 'number' ? s : f;
    var order = typeof f === 'number' ? f : s;
    handler(handleResetShoppingData, order);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  _react.default.useEffect(function () {
    if ((!customer || customer.id === anonymousContact.id) && user) {
      loadShoppingData(user);
    }
  }, [anonymousContact.id, customer, loadShoppingData, user]);

  return children;
}

AppLoadShoppingInfo.propTypes = {
  anonymousContact: _propTypes.default.shape({}).isRequired,
  children: _propTypes.default.node,

  /**
   * Registrace handleru do `Authenticate` auth pipeline.
   * Vstupem je registracni metoda se signaturou ``
   *
   * Signatura hanlder metody: `(ctx) => Promise<ctx>`
   */
  registerOnAuthenticate: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.func]).isRequired,
  registerOnLogout: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.func]).isRequired
};
AppLoadShoppingInfo.defaultProps = {
  children: null
};
var AppLoadShoppingInfoComposed = (0, _withNullIfStaticBuild.default)(AppLoadShoppingInfo);
var _default = AppLoadShoppingInfoComposed;
exports.default = _default;